import RedesignFlashSaleSwiper from "./redesignFlashsaleSwiper";
import {FlashsaleType} from "../../../helpers/loadFlashsales";
import {redesignFlashsaleSlideRender} from "./RedesignFlashsaleSlide";
import {Tracking} from "../../../tracking/tracking";

export class RedesignFlashSaleSection {
  // Instances
  private readonly flashsaleSection: HTMLElement;
  private readonly flashsaleData: FlashsaleType[];

  // ctor
  /**
   * ctor
   * @param flashsaleSection Section element holding flashsale swiper
   * @param flashsaleData Data loaded either from local sessionStorage or by fetch
   */
  constructor(flashsaleSection: HTMLElement, flashsaleData: FlashsaleType[]) {
    this.flashsaleSection = flashsaleSection;
    this.flashsaleData = flashsaleData;
    this.initRender();
    this.runRender();
  }

  /**
   * Initialize all flashsales before swiper rendering
   */
  private initRender(): void {
    if (this.flashsaleData.length === 0) {
      const parent = this.flashsaleSection.parentElement;
      if (parent !== null) {
        parent.removeChild(this.flashsaleSection);
      }

      return;
    }

    // Iterate over flashsales
    const flashsaleSlots = this.flashsaleSection.getElementsByClassName("flash-sale");
    Array.from(flashsaleSlots).forEach((anchor: HTMLAnchorElement, i: number) => {
      if (i < this.flashsaleData.length) {
        anchor.addEventListener("click", (evt) => {
          Tracking.sendPromoClick(evt.currentTarget as HTMLElement);
          Tracking.sendEvent("Homepage.SwiperBanner.Slide.Clicked");
        });
        redesignFlashsaleSlideRender(anchor, this.flashsaleData[i], this.flashsaleData.length === 1);
      } else {
        const parentDiv = anchor.parentElement;
        if (parentDiv !== null) {
          const parentContainer = parentDiv.parentElement;
          if (parentContainer !== null) {
            parentContainer.removeChild(parentDiv);
          }
        }
      }
    });
  }

  /**
   * Render swiper
   */
  private runRender(): void {
    this.flashsaleSection.style.display = "";

    RedesignFlashSaleSwiper.run(this.flashsaleSection);
  }
}
